module.exports = __webpack_public_path__ + "img/logo.5f1ca069.png";